import { apiService } from './api';

export interface Location {
  id: string;
  businessId: string;
  name: string;
  code: string;
  address: { street: string; city: string; postcode: string; country: string };
  phone?: string | null;
  email?: string | null;
  managerId?: string | null;
  isMainBranch: boolean;
  isActive: boolean;
  timezone: string;
  currency: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  manager?: { id: string; firstName: string; lastName: string; email: string } | null;
  _count?: { users: number; shifts: number };
}

export interface CreateLocationPayload {
  name: string;
  code: string;
  address: { street: string; city: string; postcode: string; country: string };
  phone?: string;
  email?: string;
  managerId?: string;
  isMainBranch?: boolean;
  timezone?: string;
  currency?: string;
  notes?: string;
}

export interface UpdateLocationPayload {
  name?: string;
  phone?: string;
  email?: string;
  managerId?: string | null;
  address?: { street: string; city: string; postcode: string; country: string };
  timezone?: string;
  currency?: string;
  notes?: string;
  isActive?: boolean;
}

export const locationsApi = {
  async getAll(): Promise<Location[]> {
    const res = await apiService.client.get<{ data: Location[] }>('/api/locations');
    return Array.isArray(res.data.data) ? res.data.data : [];
  },

  async getById(id: string): Promise<Location> {
    const res = await apiService.client.get<{ data: Location }>(`/api/locations/${id}`);
    return res.data.data;
  },

  async create(data: CreateLocationPayload): Promise<Location> {
    const res = await apiService.client.post<{ data: Location }>('/api/locations', data);
    return res.data.data;
  },

  async update(id: string, data: UpdateLocationPayload): Promise<Location> {
    const res = await apiService.client.patch<{ data: Location }>(`/api/locations/${id}`, data);
    return res.data.data;
  },

  async deactivate(id: string): Promise<Location> {
    const res = await apiService.client.patch<{ data: Location }>(`/api/locations/${id}/deactivate`);
    return res.data.data;
  },

  async setMainBranch(id: string): Promise<Location> {
    const res = await apiService.client.patch<{ data: Location }>(`/api/locations/${id}/set-main`);
    return res.data.data;
  },
};
